module.exports = __webpack_public_path__ + "static/media/dashboardIcon.e5986112.svg";